import type { CommissionStatementMonthDto } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '../../../components/ui/table';
import { formatAmount } from '../formatAmount';
import { formatMonth } from '../formatMonth';
import { FileButton } from './FileButton';
import { TransferFilesButton } from './TransferFilesButton';
import { Group } from '@folio/components/ui/flex';
import { Text } from '@folio/components/ui/text';

const Placeholder = () => (
  <Text inline tone="muted">
    —
  </Text>
);

export function MonthRow({
  month,
  showAmountDue,
  showTransferFiles,
}: {
  month: CommissionStatementMonthDto;
  showAmountDue: boolean;
  showTransferFiles: boolean;
}) {
  const { i18n } = useTranslation();
  const label = formatMonth(month.period, i18n.language);
  const report = month.files.find(({ format }) => format === 'CSV');
  const transferFiles = month.files.filter(({ format }) => format === 'XML');

  return (
    <TableRow>
      <TableCell className="capitalize">{label}</TableCell>
      {showAmountDue && (
        <TableCell className="text-right">
          {month.closed ? formatAmount(month.amountDueCents) : <Placeholder />}
        </TableCell>
      )}
      <TableCell className="text-right font-semibold">
        {month.closed ? formatAmount(month.amountToTransferCents) : <Placeholder />}
      </TableCell>
      <TableCell>
        <Group align="stretch" justify="end" gap={2}>
          <FileButton format="CSV" file={report} />
          {showTransferFiles && <TransferFilesButton files={transferFiles} />}
        </Group>
      </TableCell>
    </TableRow>
  );
}
